import Vue from 'vue'

const PATH = `${process.vars.BACKEND_HOST}/api/ui/contingents`

export default {

  update (id, params) {
    return Vue.http.put(
      `${process.vars.BACKEND_HOST}/api/ui/contingents/${id}`,
      {
        contingent: {
          daily: params.daily,
          weekly: params.weekly,
          monthly: params.monthly
        },
        contingent_amount_diff: {
          daily_remain: params.dailyRemainDiff,
          weekly_remain: params.weeklyRemainDiff,
          monthly_remain: params.monthlyRemainDiff,
          unique_remain: params.uniqueRemainDiff
        }
      }
    )
  },
  audits (id, currentPage, perPage) {
    return Vue.http.get(`${PATH}/${id}/audits?page=${currentPage}&per_page=${perPage}`)
  }
}
